<template>
  <main class="school-page small-scroll-bar small-scroll-bar--black">
    <lazy-hydrate when-visible>
      <school-new-banner
        :title="bannerTitle"
        :subtitle="bannerSubtitle"
      />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <main-certificate />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <div class="why__title">
        <div class="main-title">
          <h2>почему нас выбирают?</h2>
        </div>
        <school-new-goal />
        <school-new-choose />
      </div>
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <school-tariffs />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <main-platform v-if="onlineSchoolOtherPage" />
      <school-new-schedule v-else />
    </lazy-hydrate>

    <!--<lazy-hydrate when-visible>-->
    <!--  <school-new-quality />-->
    <!--</lazy-hydrate>-->

    <lazy-hydrate when-visible>
      <!-- eslint-disable vue/max-len -->
      <su-team
        v-if="!onlineSchoolOtherPage"
        title="<h2>обучайтесь комфортно дома <span>с&nbsp;помощью лучших специалистов</span></h2>"
        class="school-page__team"
      />
      <!-- eslint-enable -->
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <school-new-support />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <su-reviews />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <olga-block v-if="!onlineSchoolOtherPage" />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <su-faq />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <other-school-form v-if="onlineSchoolOtherPage" />
      <school-new-form v-else />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <main-necessary title="<h2>учитесь с удовольствием</h2>" />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <other-school-seo v-if="onlineSchoolOtherPage && !attestaciiPage" />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <school-new-breadcrumbs :breadcrumbs="breadcrumbs" />
    </lazy-hydrate>
  </main>
</template>

<script>
import HeadMixin from '@/mixins/HeadMixin';
import LazyHydrate from 'vue-lazy-hydration';

const SchoolNewBanner = () => import('~/components/v2/school-new/SchoolNewBanner.vue');
const SuReviews = () => import('~/components/v2/school-university/SuReviews.vue');
const MainNecessary = () => import('~/components/v2/main/MainNecessary.vue');
const SuFaq = () => import('~/components/v2/school-university/SuFaq.vue');
const SchoolNewChoose = () => import('~/components/v2/school-new/SchoolNewChoose.vue');
const SchoolNewGoal = () => import('~/components/v2/school-new/SchoolNewGoal.vue');
const SchoolNewSchedule = () => import('~/components/v2/school-new/SchoolNewSchedule.vue');
// const SchoolNewQuality = () => import('~/components/v2/school-new/SchoolNewQuality.vue');
const SuTeam = () => import('~/components/v2/school-university/SuTeam.vue');
const SchoolNewForm = () => import('~/components/v2/school-new/SchoolNewForm.vue');
const SchoolNewSupport = () => import('~/components/v2/school-new/SchoolNewSupport.vue');
const SchoolNewBreadcrumbs = () => import('~/components/v2/school-new/SchoolNewBreadcrumbs.vue');
const SchoolTariffs = () => import('~/components/v2/school-new/SchoolTariffs.vue');
const MainCertificate = () => import('~/components/v2/main/MainCertificate.vue');
const OlgaBlock = () => import('~/components/v2/common/OlgaBlock.vue');
const MainPlatform = () => import('~/components/v2/main/MainPlatform.vue');
const OtherSchoolSeo = () => import('~/components/v2/school-new/other/OtherSchoolSeo.vue');
const OtherSchoolForm = () => import('~/components/v2/school-new/other/OtherSchoolForm.vue');

export default {
  name: 'SchoolPage',
  components: {
    LazyHydrate,
    OtherSchoolForm,
    OtherSchoolSeo,
    MainPlatform,
    OlgaBlock,
    SchoolTariffs,
    SchoolNewBreadcrumbs,
    SchoolNewSupport,
    SchoolNewForm,
    SuTeam,
    // SchoolNewQuality,
    SchoolNewSchedule,
    SchoolNewGoal,
    SchoolNewChoose,
    SuFaq,
    MainNecessary,
    SuReviews,
    SchoolNewBanner,
    MainCertificate,
  },
  mixins: [HeadMixin],
  layout: 'DefaultLayoutV2',
  scrollToTop: true,
  props: {
    bannerTitle: {
      type: String,
      default: null,
    },
    bannerSubtitle: {
      type: String,
      default: null,
    },
  },

  computed: {
    zaochnoePage() {
      return this.$route.name === 'online-school-zaochnoe-obuchenie';
    },
    attestaciiPage() {
      return this.$route.name === 'online-school-attestacii-i-prikreplenie';
    },
    vecherneePage() {
      return this.$route.name === 'online-school-vechernee-obuchenie';
    },
    semeinoePage() {
      return this.$route.name === 'online-school-semeinoe-obuchenie';
    },
    semeinoePageCeny() {
      return this.$route.name === 'online-school-semeinoe-obuchenie-ceny';
    },
    onlineSchoolOtherPage() {
      return this.semeinoePage
        || this.semeinoePageCeny
        || this.vecherneePage
        || this.attestaciiPage
        || this.zaochnoePage;
    },

    breadcrumbs() {
      const breadcrumbs = [
        { text: 'главная', to: '/' },
        { text: 'домашняя школа', to: '/online-school' },
      ];

      if (this.semeinoePage || this.semeinoePageCeny) {
        breadcrumbs.push({
          text: 'семейное обучение',
          to: '/online-school/semeinoe-obuchenie',
        });
      }
      if (this.attestaciiPage) {
        breadcrumbs.push({
          text: 'прикрепление и аттестация',
          to: '/online-school/attestacii-i-prikreplenie',
        });
      }
      if (this.vecherneePage) {
        breadcrumbs.push({
          text: 'вечернее обучение',
          to: '/online-school/vechernee-obuchenie',
        });
      }
      if (this.zaochnoePage) {
        breadcrumbs.push({
          text: 'заочное обучение',
          to: '/online-school/zaochnoe-obuchenie',
        });
      }

      return breadcrumbs;
    },

    // для head
    title() {
      if (this.zaochnoePage) {
        return `Заочное обучение в онлайн-школе${this.$getTitleCityByHost()} | Заочная школа Синергии с 5 по 11 класс`;
      }

      if (this.attestaciiPage) {
        // eslint-disable-next-line max-len,vue/max-len
        return `Аттестации для семейной формы обучения и прикрепление к онлайн-школе Синергия${this.$getTitleCityByHost()}`;
      }

      if (this.vecherneePage) {
        return `Набор на вечернее обучение с 5 по 11 класс в онлайн-школе Синергия${this.$getTitleCityByHost()}!`;
      }

      if (this.semeinoePage || this.semeinoePageCeny) {
        return `Пройдите семейное обучение с 5 по 11 класс в онлайн-школе Синергия${this.$getTitleCityByHost()}`;
      }

      return 'Домашняя школа 5-11 класс | дистанционное обучение в ШУ Синергия';
    },
    description() {
      if (this.zaochnoePage) {
        // eslint-disable-next-line max-len,vue/max-len
        return 'Учитесь заочно в онлайн-школе Синергия из дома и получите аттестат государственного образца. Узнайте о всех преимущества заочной формы обучения в аккредитованной онлайн-школе с лицензией.';
      }

      if (this.attestaciiPage) {
        // eslint-disable-next-line max-len,vue/max-len
        return 'Для учащихся на семейной форме в онлайн-школе Синергия предоставляет услугу по прикреплению к школе и онлайн-аттестациям. Мы поможем вам пройти аттестацию в удобном онлайн формате и прикрепиться к нашей школе из любой точки России и мира.';
      }

      if (this.vecherneePage) {
        // eslint-disable-next-line max-len,vue/max-len
        return 'Получите школьное образование с аттестатом гос. образца на вечерней форме обучения в онлайн-школе Синергия. Пробная неделя бесплатно!';
      }

      if (this.semeinoePage || this.semeinoePageCeny) {
        // eslint-disable-next-line max-len,vue/max-len
        return 'Учитесь с комфортом на семейной форме обучения в онлайн-школе Синергия. Прикрепляйтесь к любой школе и пройдите аттестацию в удобном формате. Пробная неделя бесплатно!';
      }

      // eslint-disable-next-line max-len,vue/max-len
      return 'Онлайн-школа для 5-11 классов с лицензией и гос. аттестацией. Подготовка к ЕГЭ и ОГЭ, индивидуальные программы, IT-курсы для школьников. Начните обучение сегодня!';
    },
    image() {
      if (this.vecherneePage) return '/v2/school-new/other-pages/vechernee-share-image.jpg';
      if (this.semeinoePage || this.semeinoePageCeny) return '/v2/school-new/other-pages/semeinoe-share-image.jpg';
      if (this.attestaciiPage) return '/v2/school-new/other-pages/attestacii-share-image.jpg';
      if (this.zaochnoePage) return '/v2/school-new/other-pages/zaochnoe-share-image.jpg';

      return '/v2/school-new/share-image.jpg';
    },
  },
};
</script>

<style scoped lang="scss">

.school-page {
  padding-top: calc(var(--scale) * 120);
  padding-bottom: calc(var(--scale) * 58);
  padding-inline: calc(var(--scale) * 40);
  background-color: #ECEDF0;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  gap: calc(var(--scale) * 128);

  @include media-down($size-tablet) {
    padding-inline: calc(var(--scale) * 16);
    padding-bottom: calc(var(--scale) * 24);
    gap: calc(var(--scale) * 76);
  }

  @include media-down($size-mobile) {
    padding-inline: calc(var(--scale) * 12);
  }

  ::v-deep(*) {
    font-family: "Onest", sans-serif;
  }

  ::v-deep(.main-title) {
    position: relative;
    font-family: 'Onest', sans-serif;

    p {
      position: absolute;
      left: 0;
      top: 1.25rem;

      font-weight: 500;
      font-size: 1.625rem;
      line-height: 120%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 18);
      }

      @include media-down($size-mobile) {
        position: relative;
        top: 0;
        margin-bottom: -0.2rem;
      }

      & + h2 {
        text-indent: calc(var(--scale) * 465);

        @include media-down($size-tablet) {
          text-indent: calc(var(--scale) * 186);
        }

        @include media-down($size-mobile) {
          text-indent: 0;
        }
      }
    }

    h2 {
      font-weight: 500;
      font-size: 5.375rem;
      line-height: 110%;
      letter-spacing: -0.04em;
      color: #02120F;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 40);
      }

      span {
        color: #A7ABAC;
      }
    }
  }

  .why__title .main-title,
  .school-page__team ::v-deep(.main-title) {
    margin-bottom: calc(var(--scale) * 40);

    @include media-down($size-tablet) {
      margin-bottom: calc(var(--scale) * 24);
    }

    span {
      display: block;
    }
  }

  ::v-deep(.synergy-friends) {
    margin-bottom: 0;
  }
}

</style>
